import { Injectable, inject } from '@angular/core';
import * as VerifyUserSelectors from './verify-user.selectors';
import { Store } from '@ngrx/store';
import { VerifyUserActions } from '.';

@Injectable({
  providedIn: 'root',
})
export class VerifyUserFacade {
  private store = inject(Store);

  /**
   * State for the  verification running process
   *
   * @returns Observable<boolean>
   */
  isVerifying$ = this.store.select(VerifyUserSelectors.isVerifying);

  /**
   * Initializes the user verification process by dispatching the 'init' action to the store.
   */
  init() {
    this.store.dispatch(VerifyUserActions.init());
  }

  showAllOptions() {
    this.store.dispatch(VerifyUserActions.openVerificationDialog({}));
  }
}
